const news = {
  banner: {
    title: {
      vi: `THƯ VIỆN ESTUARY`,
      en: `ESTUARY LIBRARY`,
    },
    sub_title: {
      vi: `Tin tức, kiến thức, kinh nghiệm thực tiễn cho doanh nghiệp trong
      thời đại chuyển đổi số 4.0`,
      en: `News, knowledge and practical experiences for businesses in the 4.0 era`,
    },
  },
  sidebar: {
    featuredPosts: {
      vi: `Bài viết nổi bật`,
      en: `Featured News`,
    },
    emptyNews: {
      vi: `Chưa có bài viết nào.`,
      en: `There are no news yet.`,
    },
  },
  formRegister: {
    inputEmail: {
      vi: `Nhập email của bạn *`,
      en: `Your email *`,
    },
    inputName: {
      vi: `Tên của bạn*`,
      en: `Your name*`,
    },
    inputPhone: {
      vi: `Số điện thoại`,
      en: `Your phone number`,
    },
    inputPosition: {
      vi: `Chức vụ của bạn`,
      en: `Your job title`,
    },
    registerTitle: {
      vi: `Đăng ký nhận tài liệu`,
      en: `Subscribe for latest updates`,
    },
    labelButton: {
      vi: `Đăng ký ngay`,
      en: `Subscribe now`,
    },
  },
  popupForm: {
    title: {
      vi: `Đăng ký nhận tài liệu`,
      en: `Get free case study now`,
    },
    subTitle: {
      vi: `Điền thông tin để nhận ngay bộ tài liệu giúp <br /> <b>Gia tăng 30% doanh số bán hàng<br /> trong đại dịch Covid-19.</b>`,
      en: `Fill in the form to receive the case study of <br /> <b>increasing 30% of sales revenues during the Covid-19 pandemic.</b>`,
    },
    thanksText: {
      vi: `Cảm ơn bạn<br/>đã đăng ký nhận tài liệu`,
      en: `Thank you <br/> for your registration`,
    },
    message: {
      vi: `Case Study sẽ được gửi về Email đã đăng ký.<br/>Đừng quên kiểm tra Email bạn nhé!`,
      en: `The case study will be sent to your email.<br/>Don't forget to check it out`,
    },
    show: {
      vi: `Không hiển thị lại`,
      en: `Don't show again`,
    },
  },
};

export default news;
